module.exports = __webpack_public_path__ + "static/media/phonebook-icon.4344ee4e.svg";